import React from 'react';

function FavoritesTabIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 256 256'
    >
      <g fill='#000' strokeMiterlimit='10' strokeWidth='1'>
        <path
          d='M76.958 72.259a3.501 3.501 0 01-1.629-.402l-13.811-7.261-13.811 7.261a3.498 3.498 0 01-5.079-3.69l2.637-15.379-11.173-10.89a3.502 3.502 0 011.939-5.971l15.441-2.244 6.905-13.992a3.5 3.5 0 016.278 0l6.905 13.992L87 35.927a3.499 3.499 0 011.94 5.971l-11.17 10.89 2.638 15.379a3.497 3.497 0 01-3.45 4.092zm-32.9-30.424l7.413 7.225a3.504 3.504 0 011.006 3.099L50.728 62.36l9.162-4.816a3.496 3.496 0 013.258 0l9.162 4.816-1.75-10.202a3.504 3.504 0 011.006-3.099l7.413-7.225-10.243-1.488a3.501 3.501 0 01-2.636-1.915l-4.581-9.282-4.581 9.282a3.501 3.501 0 01-2.636 1.915l-10.244 1.489zM26.121 48.5H3.5a3.5 3.5 0 110-7h22.621a3.5 3.5 0 110 7zM40.544 29.986H3.5a3.5 3.5 0 110-7h37.044a3.5 3.5 0 110 7zM34.82 67.014H3.5a3.5 3.5 0 110-7h31.32a3.5 3.5 0 110 7z'
          transform='matrix(2.81 0 0 2.81 1.407 1.407)'
        ></path>
      </g>
    </svg>
  );
}

export default FavoritesTabIcon;
